import React, { Component } from 'react'
import Card from '@material-ui/core/Card'
import Loading from '../widgets/Loading'

import Stepper from '@material-ui/core/Stepper'
import Step from '@material-ui/core/Step'
import StepButton from '@material-ui/core/StepButton'
import { withStyles } from '@material-ui/core/styles'

import { localize } from '../util/Localizer'
import { connect } from 'react-redux'
import { logout } from '../redux/actions/logoutActions'
import {
  fetchSecurityQuestions, postAccountInfo, completeActivation,
  handleNext, handlePrev, pullStepIndex, resetStepIndex
} from '../redux/actions/activateActions'
import { toggleLanguage } from '../redux/actions/languageActions'
import { injectIntl } from 'react-intl'
import { Grid, Row, Col } from 'react-flexbox-grid'

// Our components
import StepOne from '../widgets/activate/StepOne'
import StepTwo from '../widgets/activate/StepTwo'
import StepThree from '../widgets/activate/StepThree'
import NotFound from '../components/NotFound'
import TopNav from '../widgets/common/TopNav'
import RBButton from '../controls/RBButton'

class Activate extends Component {
  constructor () {
    super()
    this.handleCancel = this.handleCancel.bind(this)
    this.sendAccountInfo = this.sendAccountInfo.bind(this)
    this.handleInputChange = this.handleInputChange.bind(this)
    this.handleDropdownChange = this.handleDropdownChange.bind(this)
    this.disableNext = this.disableNext.bind(this)
    this.handleRequestClose = this.handleRequestClose.bind(this)
    this.updateLocal = this.updateLocal.bind(this)
    this.validate = this.validate.bind(this)
    this.state = {
      finished: false,
      temporaryPassword: '',
      password: '',
      confirmPass: '',
      email: '',
      confirmEmail: '',
      securityAnswer: '',
      securityQuestion: 0,
      invalidPassLength: null,
      invalidEmail: null,
      confirmPassError: null,
      confirmEmailError: null,
      noConfirmPass: null,
      noConfirmEmail: null
    }
  }

  componentDidMount () {
    this.props.fetchSecurityQuestions()
    let storedStep = window.localStorage.getItem('stepIndex') || null
    if (storedStep) {
      this.props.pullStepIndex()
    }
  }

  handleCancel () {
    this.props.resetStepIndex()
    this.props.logout()
  }

  sendAccountInfo () {
    const { stepIndex } = this.props
    const activationInfo = {
      temporaryPassword: this.state.temporaryPassword,
      password: this.state.password,
      confirmPassword: this.state.confirmPass,
      email: this.state.email,
      confirmEmail: this.state.confirmEmail,
      securityQuestion: this.state.securityQuestion,
      securityAnswer: this.state.securityAnswer,
      username: window.localStorage.getItem('username')
    }

    if (stepIndex === 1) {
      this.props.postAccountInfo(activationInfo)
    }

    if (stepIndex === 2) {
      this.props.completeActivation(activationInfo)
    }
  }

  handleInputChange (event, newValue) {
    const targetId = event.target.id
    const state = this.state
    state[targetId] = newValue

    this.setState({ state })
  }

  validate () {
    const emailReg = new RegExp('[^@]+@[^@]+\\.[^@]+')
    const state = this.state
    // check for valid password length
    if ((state.password.length !== 0 && state.password.length < 6) || (state.password.length !== 0 && state.password.length > 15)) {
      state.invalidPassLength = localize('pages.activate.stepTwo.invalidPassLengthError')
    } else {
      state.invalidPassLength = null
    }

    // check for matches in pass, if matches reset error state
    if (state.confirmPass.length !== 0 && state.password !== state.confirmPass && !state.invalidPassLength) {
      state.confirmPassError = localize('pages.activate.stepTwo.confirmPassError')
    } else {
      state.confirmPassError = null
    }

    if (state.password.length !== 0 && state.confirmPass.length === 0 && !state.invalidPassLength) {
      state.noConfirmPass = localize('pages.activate.stepTwo.noConfirmPass')
    } else {
      state.noConfirmPass = null
    }

    // check for valid email
    if (state.email.length !== 0 && !emailReg.test(state.email)) {
      state.invalidEmail = localize('pages.activate.stepTwo.invalidEmailError')
    } else {
      state.invalidEmail = null
    }

    // check for matches in email, if matches reset error state
    if ((state.confirmEmail.length !== 0) && (state.email !== state.confirmEmail)) {
      state.confirmEmailError = localize('pages.activate.stepTwo.confirmEmailError')
    } else {
      state.confirmEmailError = null
    }

    if (state.email.length !== 0 && state.confirmEmail.length === 0 && emailReg.test(state.email)) {
      state.noConfirmEmail = localize('pages.activate.stepTwo.noConfirmEmail')
    } else {
      state.noConfirmEmail = null
    }

    this.setState({ state })
  }

  handleDropdownChange (event, index, value) {
    this.setState({ securityQuestion: event.securityQuestionsDropdown })
  }

  disableNext () {
    const { stepIndex } = this.props
    if (stepIndex === 1 && (this.state.temporaryPassword.length === 0 || this.state.password.length === 0 || this.state.confirmPass.length === 0 || this.state.email.length === 0 || this.state.confirmEmail.length === 0 || this.state.securityAnswer.length === 0 || this.state.confirmEmailError !== null || this.state.confirmPassError !== null || this.state.invalidPassLength !== null || this.state.invalidEmail !== null || this.state.noConfirmPass !== null || this.state.noConfirmEmail)) {
      return true
    }
    return false
  }

  handleRequestClose () {
    this.props.closeSnackBar()
  };

  updateLocal (stepIndex) {
    window.localStorage.setItem('stepIndex', stepIndex)
  }

  getStepContent (stepIndex) {
    if (this.props.pageLoading && stepIndex === 0) {
      return (
        <section className='activate'>
          <Loading message={localize('common.loadingContent')} />
        </section>
      )
    }
    switch (stepIndex) {
      case 0:
        return <StepOne />
      case 1:
        return <StepTwo validate={this.validate} handleInputChange={this.handleInputChange} handleDropdownChange={this.handleDropdownChange} values={this.state} questions={this.props.questions} pageErrors={this.props.error} />
      case 2:
        return <StepThree pageErrors={this.props.error} handleRequestClose={this.handleRequestClose} openSnackBar={this.props.openSnackBar} />
      default:
        return <NotFound />
    }
  }

  getButtons (stepIndex) {
    if (stepIndex === 0 && this.props.pageLoading) {
      return
    }
    return (
      <Col xs={12} md={12} lg={12}>
        <div className='buttonContainer fltRight'>
          <RBButton
            variant='outlined'
            id='cancelBtn'
            label={localize('common.cancel')}
            onClick={this.handleCancel} />
          {stepIndex !== 0 &&
            <RBButton
              variant='outlined'
              id='prevBtn'
              label={localize('common.back')}
              disabled={stepIndex === 0}
              onClick={this.props.handlePrev} />
          }
          <RBButton
            variant='contained'
            id='nextBtn'
            label={stepIndex === 2 ? localize('pages.activate.stepThree.acceptBtn') : localize('common.next')}
            disabled={this.disableNext()}
            primary
            onClick={stepIndex === 0 ? this.props.handleNext : this.sendAccountInfo}
            className={stepIndex === 2 ? 'acceptBtn' : ''}
            loading={this.props.pageLoading} />

        </div>
      </Col>
    )
  }

  render () {
    const { stepIndex, classes = {} } = this.props
    this.updateLocal(stepIndex)

    return (
      <div className='activateAccountPage'>
        <Grid fluid className='grid'>

          <TopNav primary />
          <Row>
            <Col xs={12} md={9} lg={9} className='wrapper'>
              <h2>{localize('pages.activate.title')}</h2>
              <Row className={classes.stepperRow}>
                <Col>
                  <Stepper className={classes.stepper} activeStep={stepIndex} connector={null}>
                    <Step className={classes.step}>
                      <StepButton className={classes.stepButton} />
                    </Step>
                    <Step className={classes.step}>
                      <StepButton className={classes.stepButton}/>
                    </Step>
                    <Step className={classes.step}>
                      <StepButton className={classes.stepButton}/>
                    </Step>
                  </Stepper>
                </Col>
              </Row>

              <Card className='uiCard uiCardActivate'>
                <Row>
                  <Col xs={12}>
                    {this.getStepContent(stepIndex)}
                  </Col>
                </Row>
                <Row center='xs' end='lg'>
                  {this.getButtons(stepIndex)}
                </Row>
              </Card>
            </Col>
          </Row>
        </Grid>
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
    user: state.user,
    pageLoading: state.ActivateReducers.isFetching,
    questions: state.ActivateReducers.questions,
    activationInfo: state.ActivateReducers.activationInfo,
    error: state.ActivateReducers.error,
    stepIndex: state.ActivateReducers.stepIndex,
    openSnackBar: state.ActivateReducers.openSnackBar
  }
}

const ConnectedActivate = connect(mapStateToProps, {
  logout,
  toggleLanguage,
  fetchSecurityQuestions,
  postAccountInfo,
  completeActivation,
  pullStepIndex,
  resetStepIndex,
  handleNext,
  handlePrev
})(injectIntl(Activate))

const styles = {
  stepperRow: {
    paddingLeft: 8
  },
  stepper: {
    padding: '7px 0'
  },
  step: {
    marginRight: 24,
    padding: 0
  },
  stepButton: {
    padding: 1,
    margin: 0,
    cursor: 'auto',
    '& svg': {
      width: 42,
      height: 42,
      padding: 0
    }
  }
}

export default withStyles(styles)(ConnectedActivate)



// WEBPACK FOOTER //
// ./src/components/Activate.js